import React, { Suspense } from "react";
import {
  BrowserRouter as Router,
  Switch,
  Redirect,
  Route,
  useLocation,
} from "react-router-dom";

// import { useDataSummary } from "lib/api/distancing/data-summary";

import { ConfigProvider } from "lib/config";

import { Helmet } from "react-helmet";

import { useTranslation } from "react-i18next";

import MapLoading from "components/MapLoading";

import { ThemeProvider } from "@material-ui/styles";
import useWindowSize from "@rehooks/window-size";

import Methodology from "./pages/Methodology";

import { renderContentRoutes } from "pages/ContentRoutes";

import LoginPage from "pages/LoginPage";
import LoginModal from "pages/LoginPage/LoginModal";

import { AuthProvider } from "lib/firebase-provider/Auth";
import GoogleMapsScriptProvider from "components/GoogleScriptProvider";

import { SWRConfig } from "swr";

import theme from "./theme";

import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    backgroundColor: theme.palette.background.default,
  },
}));

function Headers() {
  const { t } = useTranslation();
  return (
    <Helmet>
      <title>{t("html.header.title")}</title>
    </Helmet>
  );
}

function Routes() {

  const location = useLocation();

  const backgroundLocation = location.state && location.state.referrer;

  return (
    <>
      <Switch location={backgroundLocation || location}>
        <Route exact path="/">
          <Redirect to={{ pathname: "/distancing" }} />
        </Route>

        <Route path="/login">
          <LoginPage />
        </Route>

        {renderContentRoutes()}

        <Route path="/methodology">
          <Methodology />
        </Route>
      </Switch>
      {/* Show the modal when a background page is set */}
      {backgroundLocation && <Route path="/login" children={<LoginModal />} />}
    </>
  );
}

export default function App() {
  const windowSize = useWindowSize();
  const classes = useStyles();

  return (
    <Suspense fallback={<MapLoading />}>
      <Headers />
      <SWRConfig
        value={{
          refreshInterval: 0,
          revalidateOnFocus: false,
        }}
      >
        <GoogleMapsScriptProvider>
          <ThemeProvider theme={theme}>
            <ConfigProvider>
              <AuthProvider>
                <div
                  className={classes.container}
                  style={{ height: windowSize.innerHeight }}
                >
                  <Router>
                    <Routes />
                  </Router>
                </div>
              </AuthProvider>
            </ConfigProvider>
          </ThemeProvider>
        </GoogleMapsScriptProvider>
      </SWRConfig>
    </Suspense>
  );
}
